import { computed } from 'vue';
import type { Ref } from 'vue';
import { trainingMatrixApi } from '@/entities/Training';
import type {
  TrainingMatrixDocumentPrefix,
  TrainingMatrixMetadata,
  TrainingMatrixOrder,
  TrainingMatrixSearchField,
  TrainingMatrixSort,
} from '@/entities/Training';
import { useExcelBlobExport } from '@/shared/lib';

interface UseTrainingMatrixExportParams {
  metadata: Ref<TrainingMatrixMetadata | null>;
  search: Ref<string>;
  searchField: Ref<TrainingMatrixSearchField>;
  sort: Ref<TrainingMatrixSort | ''>;
  order: Ref<TrainingMatrixOrder | ''>;
  positionId: Ref<number | undefined>;
  documentPrefix: Ref<TrainingMatrixDocumentPrefix | undefined>;
}

export function useTrainingMatrixExport({
  metadata,
  search,
  searchField,
  sort,
  order,
  positionId,
  documentPrefix,
}: UseTrainingMatrixExportParams) {
  const hasExportableItems = computed(() => (metadata.value?.total ?? 0) > 0);

  const { handleExportToExcel, isExporting } = useExcelBlobExport(() => {
    const trimmedSearch = search.value.trim();

    return trainingMatrixApi.exportExcel({
      search: trimmedSearch || undefined,
      searchField: trimmedSearch ? searchField.value : undefined,
      sort: sort.value || undefined,
      order: order.value || undefined,
      positionId: positionId.value,
      documentPrefix: documentPrefix.value,
    });
  }, { singular: 'registro', plural: 'registros' });

  return {
    handleExportToExcel,
    isExporting,
    hasExportableItems,
  };
}
